import { LookupService as NirvanaLookupService } from "@front-shared/services/lookup.service.ts"

export class LookupService extends NirvanaLookupService {}
